
import { Link as LinkReact } from "react-router-dom";
import { _clear, _size, _style, _typeBtn } from "../../core/core";
import "../button/button.css";

interface LinkProps {
  size?: _size;
  style?: _style;
  clear?: _clear;
  type?: _typeBtn | string;
  icon_left?: React.ReactNode;
  icon_right?: React.ReactNode;
  blank?: boolean;
  link?: string | null;
  width?: string | number | null;
  isMobileWidth?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  is_default?: boolean;
  is_download?: boolean;
  children?: React.ReactNode;
}

export const Link: React.FC<LinkProps> = ({
  size = _size.S,
  style = _style.primary,
  clear = _clear,
  type = _typeBtn.default,
  icon_left = null,
  icon_right = null,
  blank = false,
  link = null,
  width = null,
  isMobileWidth = false,
  onClick = undefined,
  is_default = true,
  is_download = false,
  children,
  ...props
}) => {
  const variantsStyle = (): React.CSSProperties => {
    if (width) {
      return { width };
    }
    return {};
  };

  const variantsClassName = (): string => {
    if (type === _typeBtn.split) {
      return `button button-${size} button-width-${isMobileWidth} button-${style} split`;
    }
    return `button button-${size} button-width-${isMobileWidth} button-${style}`;
  };

  const Linking: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    if (is_default) {
      return (
        <a
          href={link || "#"}
          target={blank ? "_blank" : undefined}
          download={is_download}
          style={variantsStyle()}
          onClick={onClick}
          className={variantsClassName()}
        >
          {children}
        </a>
      );
    } else {
      return (
        <LinkReact
          to={link || "#"}
          target={blank ? "_blank" : undefined}
          style={variantsStyle()}
          onClick={onClick}
          className={variantsClassName()}
        >
          {children}
        </LinkReact>
      );
    }
  };

  return (
    <Linking>
      {icon_left}
      {children && (
        <div className={`btn-text-${size} btn-text-${style}`}>
          {children}
          {style === _style.link && <div className="button-link-line"></div>}
        </div>
      )}
      {icon_right}
    </Linking>
  );
};
